// English translations for onboarding
// Location: src/i18n/locales/en/onboarding.ts

export default {
  header: {
    step: 'Step {{current}} of {{total}}',
  },

  progress: {
    goal: 'Goal',
    bio: 'Bio',
    activity: 'Activity',
    diet: 'Diet',
    plan: 'Plan',
  },

  navigation: {
    back: 'Back',
    continue: 'Continue',
    createPlan: 'Create My Plan',
    building: 'Building your plan...',
  },

  step1: {
    title: "What is your main goal?",
    subtitle: 'Choose the goal that best describes your fitness journey',
    goals: {
      lose: {
        label: 'Lose Weight',
        description: 'Shed pounds and reach your ideal weight',
      },
      maintain: {
        label: 'Maintain Weight',
        description: 'Stay healthy and balanced',
      },
      build: {
        label: 'Build Muscle',
        description: 'Gain strength and muscle mass',
      },
    },
  },

  step2: {
    title: "Let's get to know you",
    subtitle: 'Tell us about yourself to create your personalized plan',
    gender: {
      label: 'Gender',
      male: 'Male',
      female: 'Female',
      diverse: 'Diverse',
    },
    age: {
      label: 'Age',
      placeholder: '25',
    },
    height: {
      label: 'Height (cm): {{height}} cm',
    },
    weight: {
      label: 'Current Weight (kg)',
    },
    targetWeight: {
      label: 'Target Weight (kg)',
    },
  },

  step3: {
    title: 'How active are you daily?',
    subtitle: 'This helps us calculate your calorie needs',
    levels: {
      sedentary: {
        label: 'Sedentary',
        description: 'Desk job, little to no exercise',
      },
      lightly: {
        label: 'Lightly Active',
        description: 'Light exercise 1-3 days/week',
      },
      moderately: {
        label: 'Moderately Active',
        description: 'Moderate exercise 3-5 days/week',
      },
      very: {
        label: 'Very Active',
        description: 'Hard exercise 6-7 days/week',
      },
      extremely: {
        label: 'Extremely Active',
        description: 'Very hard exercise, physical job',
      },
    },
  },

  step4: {
    title: 'Any dietary preferences?',
    subtitle: 'Select all that apply to personalize your meal plan',
    dietType: {
      title: 'Diet Type',
      subtitle: '(Select One)',
    },
    diets: {
      balanced: 'Balanced',
      vegetarian: 'Vegetarian',
      vegan: 'Vegan',
      keto: 'Keto',
      paleo: 'Paleo',
    },
    allergies: {
      title: 'Allergies/Exclusions',
      subtitle: '(Multi-select)',
    },
    allergyItems: {
      gluten: 'Gluten',
      lactose: 'Lactose',
      nuts: 'Nuts',
      soy: 'Soy',
      eggs: 'Eggs',
      fish: 'Fish',
      shellfish: 'Shellfish',
      peanuts: 'Peanuts',
    },
  },

  step5: {
    title: 'Choose Your Plan',
    subtitle: 'Select the plan that fits your goals',
    plans: {
      basic: {
        title: 'BASIC',
        price: 'CHF 14.90',
        period: '/month',
        feature1: 'Static nutrition plans',
        feature2: 'Standard basic features',
        feature3: 'Calories & ingredients per day',
        missing1: 'No access to NutriBot',
        missing2: 'No shopping lists',
        missing3: 'No real-time adjustments',
      },
      vip: {
        title: 'VIP',
        price: 'CHF 29.90',
        period: '/month',
        recommended: 'RECOMMENDED',
        feature1: 'Full access to NutriBot',
        feature2: 'Weekly VIP recipes',
        feature3: 'Smart shopping lists',
        feature4: 'Real-time plan adjustments',
        feature5: 'Motivation & coaching content',
        feature6: 'PDF exports & progress tracking',
        benefitsTitle: 'VIP Benefits',
        benefitsDesc: 'Get personalized AI coaching, weekly recipe updates, and real-time plan adjustments to reach your goals faster.',
      },
    },
    footer: {
      vip: "🎉 You're choosing the best plan! Cancel anytime.",
      basic: "✨ Start with Basic and upgrade to VIP anytime!",
      none: "Select a plan to continue",
    },
  },

  step6: {
    title: 'Meal preferences',
    subtitle: 'Customize your meal structure',
    mealsPerDay: {
      label: 'Meals per day',
    },
    allergies: {
      label: 'Allergies (select all that apply)',
      items: {
        gluten: 'Gluten',
        lactose: 'Lactose',
        nuts: 'Nuts',
        soy: 'Soy',
        eggs: 'Eggs',
        fish: 'Fish',
        shellfish: 'Shellfish',
        peanuts: 'Peanuts',
      },
    },
    intolerances: {
      label: 'Food intolerances (optional)',
      items: {
        dairy: 'Dairy',
        gluten: 'Gluten',
        grain: 'Grain',
        sulfites: 'Sulfites',
        fodmap: 'FODMAP',
        sesame: 'Sesame',
      },
    },
  },

  step7: {
    title: 'Review your profile',
    subtitle: "Everything looks good? Let's create your plan!",
    edit: 'Edit',
    personal: {
      title: 'Personal Information',
      gender: 'Gender',
      age: 'Age',
      ageValue: '{{age}} years',
      height: 'Height',
      heightValue: '{{height}} cm',
      weight: 'Weight',
      weightValue: '{{weight}} kg',
    },
    goals: {
      title: 'Goals & Activity',
      goal: 'Goal',
      target: 'Target Weight',
      targetValue: '{{weight}} kg',
      timeframe: 'Timeframe',
      timeframeValue: '{{days}} days',
      activity: 'Activity',
    },
    diet: {
      title: 'Diet Preferences',
      type: 'Diet Type',
      meals: 'Meals per Day',
      mealsValue: '{{count}} meals',
      allergies: 'Allergies',
      intolerances: 'Intolerances',
    },
    button: 'Create My Personalized Plan',
    saving: 'Saving...',
    note: '🎉 Your personalized nutrition plan will be generated in 2-3 minutes!',
  },
  addAllergy: {
    title: 'Add Custom Allergy',
    description: 'Enter an ingredient or food you are allergic to so we can personalize your meals.',
    inputPlaceholder: 'e.g. Peanuts',
    cancel: 'Cancel',
    add: 'Add'
  }
};